'use client';

import type { Config } from '@packages/config';
import config from '@packages/config';
import { defineMessages, useIntl } from 'react-intl';
import { ItemWrapper } from '../../atoms/ItemWrapper/ItemWrapper';

const PAYMENT_METHODS_TEXT_BASED_LOCALS = defineMessages<
  Config['paymentMethods']['textBased'][number]
>({
  bank_debit: {
    id: 'paymentMethods.textbased.bank_debit',
    defaultMessage: 'Bankeinzug',
  },
  flexikonto: {
    id: 'paymentMethods.textbased.flexikonto',
    defaultMessage: 'Flexikonto',
  },
  installments: {
    id: 'paymentMethods.textbased.installments',
    defaultMessage: 'Ratenzahlung',
  },
  invoice: {
    id: 'paymentMethods.textbased.invoice',
    defaultMessage: 'Rechnung',
  },
});

export const PaymentMethodsTextBased = () => {
  const { formatMessage } = useIntl();
  const {
    paymentMethods: { textBased },
  } = config;

  return (
    <>
      {textBased.map((method) => (
        <ItemWrapper key={method}>
          <span className="text-size-body-xs text-color-text-dark bg-color-grey-light rounded-full px-1.5 py-0.5">
            {formatMessage(PAYMENT_METHODS_TEXT_BASED_LOCALS[method])}
          </span>
        </ItemWrapper>
      ))}
    </>
  );
};
